module.exports = __webpack_public_path__ + "img/AddBoxOutlined.00af167e.svg";